import { render, staticRenderFns } from "./GetSatelliteImg.vue?vue&type=template&id=6af67be4&scoped=true"
import script from "./GetSatelliteImg.vue?vue&type=script&lang=js"
export * from "./GetSatelliteImg.vue?vue&type=script&lang=js"
import style0 from "./GetSatelliteImg.vue?vue&type=style&index=0&id=6af67be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af67be4",
  null
  
)

export default component.exports